import { Component, OnInit ,Input} from '@angular/core';
import { BatchService } from 'src/services/batch.services';
import { EventBusService } from 'src/services/event-bus.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { PackageChildrenComponent } from './package-children/package-children.component';
import { MatDialog } from '@angular/material';
import { MedicineDetailComponent } from '../medicine-detail/medicine-detail.component';
import { ConfirmationDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MessageService } from 'src/services/message.service';
@Component({
  selector: 'app-manage-package',
  templateUrl: './manage-package.component.html',
  styleUrls: ['./manage-package.component.css']
})
export class ManagePackageComponent implements OnInit {
  @Input() batchNum: string;
  gcp: string;
  selectedPkgLvl: string = "all";

  bookmarks: any[] = [];
  totalCount: number = 0;
  pageSize: number = 5;
  page: any;
  searchByBatch: boolean = false;
  packageData: any[] = [];
  columns: any[];
  labels: any;
  searchTxt: string = '';
  subscriptions: any[] = [];

  packageLevels: any[] = [
    {displayName: "Inner Secondary", name: "inner-secondary"},
    {displayName: "Secondary", name: "secondary"},
    {displayName: "Outer Secondary", name: "outer-secondary"},
    {displayName: "Tertiary", name: "tertiary"}
  ];

  constructor(
    private batchService: BatchService,
    private ebService: EventBusService,
    private globalCfgService: GlobalCfgService,
    private dialog: MatDialog,
    private msgService: MessageService,
  ) { }

  ngOnInit() {
    this.loadPackages();

    this.subscriptions.push(this.ebService.particpantSelectionFetchedValue$.subscribe(
      (gcp) => {
        this.gcp = gcp;
        this.loadPackages();
      }
    ));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  loadPackages(page?) {
    this.labels = this.globalCfgService.getSettingValue('labels');
    this.columns = [
      { name: "packageId", displayName: "Package Id" },
      // { name: "packageLevel", displayName: "Package Level" },
      { name: "packageType", displayName: "Package Type" },
      { name: "packageGtin", displayName: "Package GTIN" },
      { name: 'batchNo', displayName:'Batch No'},
      { name: "batchDt", displayName: "Batch Date", type: 'date', format: "DD/MM/YYYY" },
      { name: "expiryDt", displayName: "Expiry Date", type: 'date', format: "DD/MM/YYYY" },
      { name: "qty", displayName: "Quantity"},
      { name: "name", displayName: this.labels['medicine'], actionable: true },
      // { name: "children", displayName: "", actionable: true },
      { name: "actions", type: "actions", displayName: "" }
    ];

    if (!this.gcp) {
      this.gcp = this.globalCfgService.getGcp();
    }

    var obj = {
      gcp: this.gcp
    };

    if (this.selectedPkgLvl != 'all') {
      obj['packageLevel'] = this.selectedPkgLvl;
    }

    if (this.batchNum) {
      obj["batch"] = this.batchNum;
      this.searchTxt = this.batchNum;
      this.searchByBatch = true;
    }
    if (this.searchByBatch) {
      obj['batch'] = this.searchTxt;
    }

    obj['pageSize'] = (page && page.pageSize) || this.pageSize;

    if (page && page.pageIndex) {
      obj['bookmark'] = this.bookmarks[page.pageIndex];
    }

    this.batchService.getPackages(obj).subscribe((response: any[]) => {
      if (page && page.pageIndex) {
        this.bookmarks[page.pageIndex + 1] = response['metadata'].bookmark;
      } else {
        this.bookmarks[1] = response['metadata'].bookmark;
      }
      this.totalCount = response['metadata'].totalCount;

      response['result'].forEach(item => {
        var actions = [];

        if (!item["isCancelled"]) {
          actions.push({ name: "cancel", tip: "Cancel Package" });
        }
        if (item["children"].length > 0) {
          actions.push({ name: "group_work", tip: "View Children" });
        }
        item["actions"] = actions;
      });
      this.packageData = Object(response['result']);
    });
  }

  applyFilter() {
    this.loadPackages();
  }

  onActionableClicked(e) {
    console.log("onActionableClicked:", e);
    var rec = e.record;
    switch (e.actionName) {
      case "name":
        this.dialog.open(MedicineDetailComponent, {
          width: "2400px",
          data: { medicineId: rec.gtin }
        });
        break;
      default:
        console.log("Unhandled actionable: ", e.actionName);
    }
  }

  onActionClicked(e) {
    console.log("onActionClicked: ", e);
    var rec = e.record;
    switch (e.actionName.name) {
      case "group_work":
        var arrData = rec.children;
        var childrenData = [];
        arrData.forEach(element => {
          childrenData.push({
            medicine: rec.name,
            packageId: rec.packageId,
            instanceId: element
          });
        });
        this.dialog.open(PackageChildrenComponent, {
          width: "2400px",
          data: { childrenData: childrenData }
        });
        break;
      case "cancel":
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '450px',
          data: {
            message: 'Are you sure you want to cancel the package?'
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result == 'yes') {
            this.batchService.cancelPackage({packageId: rec.packageId}).subscribe(
              (response: any[]) => {
                this.msgService.showSuccess(this.msgService.packageDelete);
                this.loadPackages();
              },
              error => {
                console.log("Service error:");
              }
            );
          }
        });
        break;
      default:
        console.log("Unhandled action: ", e.actionName);
    }
  }

  styleRow(rec) {
    if (rec.isCancelled) {
      return "invalid-row";
    }
  }

  showRecalledBatchTip(rec) {
    if (rec.isCancelled) {
      return 'Package has been cancelled';
    }
  }

  onPageChanged(page) {
    this.pageSize = page.pageSize;
    this.loadPackages(page);
  }
  
  setSearchByBatch(status) {
    if (!status && this.searchTxt.length > 0) {
      return;
    }
    this.searchByBatch = status;
  }

  clear() {
    this.searchTxt = '';
    this.searchByBatch = false;
    this.applyFilter();
  }

}

